/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import { makeStyles } from '@material-ui/core';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import camelCaseToTitleCase from 'src/helpers/camelCaseToTitleCase';
import { getPassword } from 'src/services/napi';
import { sortByObjValues, updateDynamicObject, valueType } from './helpers';
import { removeItemFromCustomerDraftAction } from '../../../actions/customersAction';
import copyIcon from '../../../asset/copy.svg';
import eyeIcon from '../../../asset/eye-open.svg';
import crossedEyeIcon from '../../../asset/hide.svg';
import CButton from '../../../component/Button';
import { CStandardInput } from '../../../component/Input';
import Modal from '../../../component/Modal/Modal';

const useStyles = makeStyles({
  buttonSvg: {
    '& img': {
      display: 'block',
      width: '18px'
    },
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    display: 'inline-block',
    margin: '0',

    padding: '0',
    width: '18px'
  },
  firstAndLastName: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    justifyContent: 'center'
  },
  passwordWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  phoneWrapper: {
    alignItems: 'center',
    display: 'flex'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  },
  wrapperDiv: {
    display: 'grid',
    gap: '12px',
    gridTemplateColumns: '1fr 1fr 1fr',
    justifyContent: 'start',
    width: '100%'
  }
});

const restrictedData = [
  'project',
  'createdAt',
  'updatedAt',
  'EmailVerificationToken',
  '0',
  'metadata',
  'imageUrl',
  'fcmTokens',
  'friends',
  'favoriteOffers',
  'deviceIds',
  'password'
];

const CustomerDetailEditModal = (props) => {
  const { open, setOpen, customer, customerDraft, setCustomerDraft, onUpdate } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const [isPhoneVerified, setIsPhoneVerified] = useState(customer?.isPhoneVerified);
  const [isEmailVerified, setIsEmailVerified] = useState(customer?.isEmailVerified);
  const [hasApartment, setHasApartment] = useState(customer?.metadata?.haveAppartment);
  const [isPaymentCardConfirmed, setIsPaymentCardConfirmed] = useState(
    customer?.metadata?.paymentCardConfirmed
  );

  const projectId = useSelector(({ project }) => project.currentProject._id);

  const isCurrentProjectCapstone = projectId === '627286c61f83a577456beb1e';

  const onModalCancel = () => {
    setOpen(false);
    if (isCurrentProjectCapstone) {
      dispatch(removeItemFromCustomerDraftAction('password'));
    }
  };

  const generatePassword = async () => {
    const response = await getPassword(projectId);

    setCustomerDraft({ ...customer, password: response.data.generatedPassword });
    navigator.clipboard.writeText(response.data.generatedPassword);
    alert('Password copied');
  };

  const onTick = (item) => {
    switch (item) {
      case 'isEmailVerified':
        setIsEmailVerified(!isEmailVerified);
        break;
      case 'isPhoneVerified':
        setIsPhoneVerified(!isPhoneVerified);
        break;
      case 'haveApartment':
        setHasApartment(!hasApartment);
        break;
      default:
        setIsPaymentCardConfirmed(!isPaymentCardConfirmed);
    }
  };

  const generateDuplicatePathArr = (arr = [], key) => {
    const duplicatePathArr = arr.slice();
    duplicatePathArr.push(key);
    return duplicatePathArr;
  };

  const modalContent = (data, pathArr = []) => {
    return (
      <>
        {Object.entries(data)
          .sort((a, b) => sortByObjValues(a, b, data))
          .map(([key, value], i) => {
            if (value !== null && valueType(value) === 'object' && key !== 'friends') {
              return modalContent(value, [key]);
            }
            if (data.fullName) {
              if (
                key === 'firstName' ||
                key === 'lastName' ||
                restrictedData.includes(key || key?.toLowerCase().includes('id'))
              ) {
                return false;
              }
            }
            if (restrictedData.includes(key) || key?.toLowerCase().includes('id')) {
              return false;
            }
            if (typeof value === 'boolean') {
              return (
                <FormControlLabel
                  key={i}
                  className="tick"
                  control={
                    <Checkbox
                      defaultChecked={
                        (key === 'isEmailVerified' && !!isEmailVerified) ||
                        (key === 'isPhoneVerified' && !!isPhoneVerified) ||
                        (key === 'paymentCardConfirmed' && !!isPaymentCardConfirmed) ||
                        (key === 'haveAppartment' && !!hasApartment)
                      }
                      onChange={() => {
                        onTick(key);
                        if (key === 'paymentCardConfirmed') {
                          setCustomerDraft({
                            ...customerDraft,
                            metadata: {
                              ...customerDraft.metadata,
                              [key]: !isPaymentCardConfirmed
                            }
                          });
                        } else if (key === 'haveAppartment') {
                          setCustomerDraft({
                            ...customerDraft,
                            metadata: {
                              ...customerDraft.metadata,
                              [key]: !hasApartment
                            }
                          });
                        } else {
                          setCustomerDraft({
                            ...customerDraft,
                            [key]: key === 'isEmailVerified' ? !isEmailVerified : !isPhoneVerified
                          });
                        }
                      }}
                      sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                    />
                  }
                  label={camelCaseToTitleCase(key)}
                  labelPlacement="top"
                  sx={{ alignSelf: 'start' }}
                />
              );
            }
            return (
              <CStandardInput
                key={i}
                allowClear
                disableUnderline
                formclasses={{ root: classes.root }}
                htmlFor={`standard-customer-edit-${key}`}
                id={`standard-customer-edit-${key}`}
                label={camelCaseToTitleCase(key)}
                onChange={(e) => {
                  const { value } = e.target;

                  const updatedObject = updateDynamicObject(
                    customerDraft,
                    generateDuplicatePathArr(pathArr, key),
                    value
                  );
                  setCustomerDraft(updatedObject);
                }}
                size="large"
                value={customerDraft.length ?? value}
              />
            );
          })}
        {isCurrentProjectCapstone && (
          <div className={classes.passwordWrapper}>
            <CStandardInput
              adornment={
                <>
                  <button
                    className={classes.buttonSvg}
                    onClick={() => {
                      navigator.clipboard.writeText(customerDraft.password || '');
                    }}
                    style={{
                      marginRight: '5px'
                    }}
                    type="button"
                  >
                    <img alt="copy password" src={copyIcon} />
                  </button>
                  <button
                    className={classes.buttonSvg}
                    onClick={() => setIsPasswordHidden(!isPasswordHidden)}
                    type="button"
                  >
                    <img
                      alt="toggle password visibility"
                      src={isPasswordHidden ? crossedEyeIcon : eyeIcon}
                    />
                  </button>
                </>
              }
              disableUnderline
              formclasses={{ root: classes.root }}
              htmlFor="standard-input-user-password"
              id="standard-input-user-password"
              label="Password"
              onChange={(e) => setCustomerDraft({ ...customer, password: e.target.value })}
              size="large"
              type={isPasswordHidden ? 'password' : 'text'}
              value={customerDraft.password || ''}
              width="true"
            />
            <CButton
              onClick={generatePassword}
              type="primary"
              xstyle={{
                borderRadius: '12px',
                margin: '16px 0px 0px 16px'
              }}
            >
              Generate
            </CButton>
          </div>
        )}
      </>
    );
  };

  return (
    <Modal
      footerActions={
        <>
          <CButton
            htmlType="submit"
            onClick={(e) => {
              setOpen(false);
              e.preventDefault();
            }}
            size="large"
            type="secondary"
          >
            Cancel
          </CButton>
          <CButton
            htmlType="submit"
            onClick={onUpdate}
            size="large"
            type="primary"
            // disabled={!isSaveEnabled}
          >
            Save
          </CButton>
        </>
      }
      handleClose={onModalCancel}
      isModalOpen={open}
      styles={{
        '& .MuiDialogContent-root': {
          paddingBottom: '24px'
        },
        maxWidth: '770px',
        width: customerDraft ? '770px' : '385px'
      }}
      titleContent={<span className="modal-title">Edit User</span>}
    >
      <form className={classes.form} id="customer-edit-form">
        <div className={classes.wrapperDiv}>{modalContent(customerDraft, [])}</div>
      </form>
    </Modal>
  );
};

export default CustomerDetailEditModal;
